import { ArrowForward, PlayArrowRounded } from '@mui/icons-material';
import { CardVariant } from '../types';

const focusIconStyle = {
    color: 'white',
    border: '2px solid white',
    borderRadius: '50%',
};

export const styleFocusIconHorizontal = {
    ...focusIconStyle,
    width: 60,
    height: 60,
    p: 3,
};

export const styleFocusIcon = {
    ...focusIconStyle,
    width: 80,
    height: 80,
    p: 4,
};

export interface FocusIconProps {
    variant?: CardVariant;
}

export function PlayFocusIcon({ variant }: FocusIconProps) {
    return (
        <PlayArrowRounded
            sx={
                variant === CardVariant.Horizontal
                    ? styleFocusIconHorizontal
                    : styleFocusIcon
            }
        />
    );
}
export function ForwardFocusIcon({ variant }: FocusIconProps) {
    return (
        <ArrowForward
            sx={
                variant === CardVariant.Horizontal
                    ? styleFocusIconHorizontal
                    : styleFocusIcon
            }
        />
    );
}
